import * as React from 'react'

import { withAuthenticationRequired } from '@enechain/auth-js'
import { LoadingEnechainLogo } from '@enechain/ecloud-designsystem'

export const ProtectedAuthGuard: (
  component: React.ComponentType,
) => React.FC = (component: React.ComponentType) => {
  return withAuthenticationRequired(component, {
    onLoading: () => <LoadingEnechainLogo />,
    onRedirecting: () => <LoadingEnechainLogo />,
    returnTo: window.location.href,
  })
}
